import { createFileRoute, redirect } from '@tanstack/react-router'
import { ROLE_LIST_VIEW } from '~/components/routes/administration/roles/permissions'
import { withRoutePermissions } from '~/utils/rbac'

/**
 * `/administration/roles` — ancienne liste des rôles, **absorbée** par l'axe « Par rôle » de
 * `/administration/access` (spec §3.1, §4.2).
 *
 * La fiche d'un rôle (`/administration/roles/$roleId`), sa création et son éditeur restent des
 * écrans pleins : seule la **liste** disparaît, et cette route la redirige pour ne casser aucun
 * lien existant.
 */
export const Route = createFileRoute('/_authenticated/administration/roles/')({
  staticData: { permission: ROLE_LIST_VIEW },
  beforeLoad: () => {
    throw redirect({ to: '/administration/access' })
  },
})
withRoutePermissions(Route)
